import { RootState } from '@reducers/index';

export const getSearchTerm = (state: RootState, type: string): string =>
    state.searchTermsReducer[type];
